import { LabelProps } from "@ptomasroos/react-native-multi-slider";
import React, { useCallback } from "react";

import BaseMultiSlider from "@/components/molecules/BaseMultiSlider";

/**
 *
 */
interface MultiSliderViewProps {
  value: number[];
  onChange: (value: [number, number]) => void;
  minValue: number;
  maxValue: number;
  step?: number;
  width?: number;
  renderCustomLabel?: React.ComponentType<LabelProps>;
  useLogScale?: boolean;
}

/**
 * Container component for linear multi-slider with linear value transformation
 * @param props - Slider configuration props including value range, step size, and callbacks
 */
const LinearMultiSliderContainer: React.FC<
  Omit<MultiSliderViewProps, "useLogScale">
> = props => {
  const transformValue = useCallback((val: number): number => val, []);
  const inverseTransformValue = useCallback((val: number): number => val, []);
  const getStepSize = useCallback((): number => props.step ?? 1, [props.step]);

  const handleValuesChange = useCallback(
    (values: number[]) => {
      const clampedValues = [
        values[0],
        Math.min(Math.max(values[1], values[0]), props.maxValue),
      ] as [number, number];

      props.onChange(clampedValues);
    },
    [props]
  );
  return (
    <BaseMultiSlider
      {...props}
      transformValue={transformValue}
      inverseTransformValue={inverseTransformValue}
      getStepSize={getStepSize}
      handleValuesChange={handleValuesChange}
    />
  );
};

export default LinearMultiSliderContainer;
